var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.purchaseComplete)?_c('div',[_c('refill-complete')],1):_c('div',[_c('refill-methods')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }